/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/whats_app/message_templates" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdWhatsAppMessageTemplatesProps,
  PostWhatsAppMessageTemplateResponse,
} from "./types";

export const postWhatsAppMessageTemplate = reactQueryMutationAdapter(
  engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys,
  ({
    appGroupId,
    requestBody,
  }: PostEngagementAppGroupIdWhatsAppMessageTemplatesProps): Promise<PostWhatsAppMessageTemplateResponse> => {
    return fetch(`/engagement/${appGroupId}/whats_app/message_templates`, "POST", requestBody, undefined, {
      // display an error toast on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
